import api from './apiLibrary';

const API = {
    resubscribe() {
        return api.post('/api/admin/tixx/resubscribe');
    },
};

export default API;
